import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(private httpService: HttpService) { }
  fetchRoles(payload: any) {
    return this.httpService.getList('api/Role', payload);
  }
  submitRole(payload: any) {
    if (payload?.id) {
      return this.httpService.put('api/Role/' + payload?.id, payload);
    } else {
      return this.httpService.post('api/Role', payload);
    }
  }
  roleDetails(id: string) {
    return this.httpService.get('api/Role/' + id);
  }
  deleteRole(id: string) {
    return this.httpService.delete('api/Role/' + id);
  }
}
